import { chakra } from '@chakra-ui/react';
import type { FC } from 'react';

const TextAd: FC<{ className?: string }> = () => null;

export default chakra(TextAd);
